module.exports = __webpack_public_path__ + "static/media/pen-icon.50c2bd5d.svg";